import React from 'react';
import { regions } from '../utils/regionData';
interface RegionSelectorProps {
  selectedRegion: string;
  onRegionChange: (region: string) => void;
}
export function RegionSelector({
  selectedRegion,
  onRegionChange
}: RegionSelectorProps) {
  return <section className="bg-white rounded-xl shadow-md p-6" data-id="element-130">
      <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-131">
        Select Your Region
      </h2>
      <div className="relative" data-id="element-132">
        <select className="w-full p-3 border border-gray-300 rounded-lg appearance-none bg-white text-gray-800 focus:outline-none focus:ring-2 focus:ring-green-600 focus:border-transparent" value={selectedRegion} onChange={e => onRegionChange(e.target.value)} data-id="element-133">
          {regions.map(region => <option key={region.name} value={region.name} data-id="element-134">
              {region.name}
            </option>)}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700" data-id="element-135">
          <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" data-id="element-136">
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" data-id="element-137" />
          </svg>
        </div>
      </div>
    </section>;
}